var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link btn btn-outline-primary",staticStyle:{"padding":"8px"},on:{"click":_vm.logout}},[_c('b-icon',{attrs:{"icon":"power"}}),_vm._v("Αποσύνδεση\n  ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }